import { render, staticRenderFns } from "./SupportTicketSaveFileDialog.vue?vue&type=template&id=9c2f927a&"
import script from "./SupportTicketSaveFileDialog.vue?vue&type=script&lang=ts&"
export * from "./SupportTicketSaveFileDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports